import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { Radii, Size } from '~/types/ThemeTypes'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const { CallButton: CallButtonColors } = phoneColorKeys.Phone

export enum CallButtonVariants {
  Start = 'start',
  Stop = 'stop',
  Disabled = 'disabled',
}

const callButtonParts = ['button', 'icon', 'tooltip'] as const
const helpers = createMultiStyleConfigHelpers(callButtonParts)

export const CallButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    button: {
      boxSize: Size.full,
      borderRadius: Radii.full,
    },
    icon: {
      boxSize: '26px',
      color: CallButtonColors.Icon,
    },
  },
  sizes: {
    [Size.sm]: {
      button: {
        boxSize: '60px',
      },
    },
    [Size.md]: {
      button: {
        boxSize: '80px',
      },
    },
    [Size.lg]: {
      button: {
        boxSize: '100px',
      },
    },
    [Size.full]: {
      button: {
        boxSize: Size.full,
      },
    },
  },
  variants: {
    [CallButtonVariants.Start]: {
      button: {
        bg: CallButtonColors.Variants.Start.Background,
        _hover: {
          bg: CallButtonColors.Variants.Start.Hover.Background,
        },
        _active: {
          bg: CallButtonColors.Variants.Start.Active.Background,
        },
      },
    },
    [CallButtonVariants.Stop]: {
      button: {
        bg: CallButtonColors.Variants.End.Background,
        _hover: {
          bg: CallButtonColors.Variants.End.Hover.Background,
        },
      },
    },
    [CallButtonVariants.Disabled]: {
      button: {
        bg: CallButtonColors.Variants.Disabled.Background,
        _hover: {
          cursor: 'default',
        },
      },
      tooltip: {
        display: 'none',
      },
    },
  },
  defaultProps: {
    size: Size.full,
  },
})

export const useCallButtonStyles = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ CallButtonStyle }),
    props,
  ) as MultiStyleType<typeof callButtonParts>
}
